import React from 'react'
import PropTypes from 'prop-types'
import { LocalizedText, IconAction, PermissionTooltip, useRouter, useHandler, ModalContext } from 'labguard-cdk'
import { useGroupId, useAppPermission } from 'src/hooks'
import { InfoCircleIcon } from 'labguard-cdk/src/components/icons'
import ChannelInfoTooltip from '../ChannelInfoTooltip'
import { ConfigurationIcon, RemoveIcon } from '../icons'
import DeleteChannelModal from './DeleteChannelModal'

const ChannelActions = ({ channel, showInfo, showConfigure, showDelete }) => {
  // get permission
  const enableDelete = useAppPermission('channels.delete')

  // get history push handler
  const {
    history: { push },
  } = useRouter()

  // get group id if any
  const groupId = useGroupId()

  // get modal opener
  const { createModalOpener } = ModalContext.use()

  // create remove handler
  const onRemoveClick = createModalOpener(<DeleteChannelModal channelId={channel.id} />)

  // create configure handler
  const onConfigurationClick = useHandler(() =>
    push(`${groupId ? `/groups/${groupId}` : ''}/channels/${channel.id}/configuration`)
  )

  return (
    <div>
      {showInfo && (
        <ChannelInfoTooltip channelId={channel.id}>
          <IconAction icon={InfoCircleIcon} size="lg" />
        </ChannelInfoTooltip>
      )}
      {showConfigure && (
        <IconAction
          tooltip={<LocalizedText id="WEB_CONFIGURE_CHANNEL" />}
          icon={ConfigurationIcon}
          size="lg"
          onClick={onConfigurationClick}
        />
      )}

      {showDelete && (
        <PermissionTooltip allowed={enableDelete}>
          <IconAction
            icon={RemoveIcon}
            disabled={!enableDelete}
            size="lg"
            tooltip={<LocalizedText id="WEB_DELETE_CHANNEL" />}
            onClick={onRemoveClick}
          />
        </PermissionTooltip>
      )}
    </div>
  )
}

ChannelActions.propTypes = {
  channel: PropTypes.object,
  showInfo: PropTypes.bool,
  showConfigure: PropTypes.bool,
  showDelete: PropTypes.bool,
}

export default ChannelActions
